import { Navigate, Outlet } from "react-router-dom";
import { useRedirectRules } from "hooks/useRedirectRules";

const Redirector = () => {
  const redirectTo = useRedirectRules();

  if (redirectTo) {
    return <Navigate to={redirectTo} />;
  }

  return <Outlet />;
};

export default Redirector;
